/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Widget Multi Balances Translation
 *
 * @author Aleksandr Perkhunov
 * @version 1.11.0
 * @since 1.10.0
 */

import IWidgetMultiBalancesTranslation from '../../../types/pages/dashboard/widgetMultiBalancesTranslation';

const initWidgetMultiBalancesTranslation: IWidgetMultiBalancesTranslation = {
    error: {
        defaultMessage: '',
        codes: {},
    },
    moreLink: '',
    title: '',
};

export default initWidgetMultiBalancesTranslation;
